document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll("[data-scroll-reveal]");

  if (window.innerWidth > 768) { 
    elements.forEach(el => {
      const origin = el.getAttribute("data-scroll-reveal") || "bottom";

      ScrollReveal().reveal(el, {
        origin: origin,
        distance: "60px",
        duration: 900,
        delay: 300,
        reset: true
      });
    });
  } 
});
